// extracted by mini-css-extract-plugin
export default {"redPoint":"navbar_redPoint__jL8pe"};